module.exports = __webpack_public_path__ + "static/media/activities.86f50c45.png";


//////////////////
// WEBPACK FOOTER
// ./src/App/account/assets/images/activities.png
// module id = 1254
// module chunks = 2